var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.enabled)?_c('div',{staticClass:"vanta-container",attrs:{"id":_vm.vantaId}},[_vm._t("default")],2):_c('div',{staticClass:"vanta-container",attrs:{"id":_vm.vantaId}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }